
























































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component } from 'vue-property-decorator';
import BaseFormEdit from '../../models/base.form.edit';
import Donor from '../../models/donorForm';
import AddressTab from '../donorsForm/Address.vue';
import PhoneTab from '../donorsForm/Phones.vue';
import MailTab from '../donorsForm/Mails.vue';
import SocialNetworkTab from '../donorsForm/SocialNetworks.vue';
import axios from 'axios';
import { Prop } from 'vue-property-decorator';

@Component({
  components: {
    AddressTab,
    PhoneTab,
    MailTab,
    SocialNetworkTab,
  },
  props: ['labId', 'patientId', 'requestDate'],
})
export default class Edit extends BaseFormEdit {
  public form: any = new Donor();
  public urlPrefix = 'pmdd';

  @Prop()
  public labId: any;
  @Prop()
  public patientId: any;
  @Prop()
  public requestDate: any;
  public genders: any[] = [];
  public registerJoinTypes: any[] = [];
  public bloodTypes: any[] = [];
  public biomaterialSamples: any[] = [];
  public regions: any[] = [];
  public rhs: any[] = [];
  public deletionReasons: any[] = [];
  public initialDeletionReasons: any[] = [];
  public learnedFroms: any[] = [];
  public diseases: any[] = [];
  public dataProcessingAgreements: any[] = [];
  public socialNetworks: any[] = [];
  public startForm: any = '';
  public otherRegisterJoinType: any = 5;

  get yesNoOptions() {
    return [
      { text: this.$t('Не выбрано'), value: '' },
      { text: this.$t('Да'), value: true },
      { text: this.$t('Нет'), value: false },
    ];
  }

  get readyOptions() {
    return [
      { text: this.$t('Согласен'), value: true },
      { text: this.$t('Не согласен'), value: false },
    ];
  }

  get isReadOnlyMode() {
    return (this.$auth.user().functions.find((t) => t.routeName === 'DonorsFormEditInDonorAtWork') == null);
  }

  public isLabIdUnique = {
    validate(value: any, args: any) {
      return axios.get('/pmdd/donorsForm/validateLabId?lab=' + value + '&id=' + args[0])
                  .then((response) => {
                    return response.data;
                  });
    },
  };

  public async save() {
    if (!this.isReadOnlyMode && this.startForm !== JSON.stringify(this.form)) {
      await axios.post('/pmdd/donorsForm', { entity: this.form });
      this.startForm = JSON.stringify(this.form);
    }
  }

  public isReadyChanged(e, row) {
    if (e) {
      this.clearProps(row, ['refusal_reason_comment', 'register_join_type_id', 'other_register_join_type_comment']);
    } else {
      this.clearProps(row, ['has_breast_feeding', 'breast_feeding_comment',
                            'has_operations_for_last4_months', 'operations_for_last4_months_comment',
                            'has_vaccinations_in_last_month', 'vaccinations_in_last_month_comment',
                            'has_chronic_diseases', 'chronic_diseases_comment', 'has_travel_plans_for_next3_months',
                            'travel_plans_for_next3_months_comment', 'has_consent_of_relatives', 'consent_of_relatives_comment']);
    }
  }

  public newContact() {
    const contact = {
        order_num: 0,
        is_call_successful: '',
        is_mail_successful: '',
        is_social_network_successful: '',
        is_messenger_successful: '',
        is_ready: '',
        has_breast_feeding: '',
        has_operations_for_last4_months: '',
        has_vaccinations_in_last_month: '',
        has_chronic_diseases: '',
        has_travel_plans_for_next3_months: '',
        has_consent_of_relatives: '',
        patient_id: null,
    };
    contact.patient_id = this.patientId;
    return contact;
  }

  public isCallSuccessfulChanged(e, row, rowIndex) {
    const contact = this.newContact();
    if (e === false) {
      let isExist = false;
      for (const contactIndex in this.form.donor_first_contacts) {
        if (JSON.stringify(this.form.donor_first_contacts[contactIndex]) === JSON.stringify(contact)) {
          isExist = true;
          break;
        }
      }
      if (!isExist) {
        this.form.donor_first_contacts.push(contact);
      }
    }
    if (!e) {
      this.clearProps(row, ['has_breast_feeding', 'breast_feeding_comment', 'is_ready',
                            'refusal_reason_comment', 'register_join_type_id', 'other_register_join_type_comment',
                            'has_operations_for_last4_months', 'operations_for_last4_months_comment',
                            'has_vaccinations_in_last_month', 'vaccinations_in_last_month_comment',
                            'has_chronic_diseases', 'chronic_diseases_comment', 'has_travel_plans_for_next3_months',
                            'travel_plans_for_next3_months_comment', 'has_consent_of_relatives', 'consent_of_relatives_comment']);
    }

    if (e || e === '') {
      this.clearProps(row, ['mail_date', 'is_mail_successful',
                            'social_network_date', 'is_social_network_successful',
                            'messenger_date', 'is_messenger_successful']);

      const ind = this.form.donor_first_contacts.length - 1;
      if (e && ind > 0 && rowIndex !== ind &&
          JSON.stringify(this.form.donor_first_contacts[ind]) === JSON.stringify(contact)) {
        this.form.donor_first_contacts.splice(ind, 1);
      }
    }
    this.setFirstContactsOrderIndex();
  }

  public saveDuplicate(param) {
    const msgHtml = document.createElement('div');
    msgHtml.innerHTML = param.message;
    const self = this;
    // @ts-ignore
    this.$swal({
      icon: 'warning',
      title: this.$t('Предупреждение'),
      content: msgHtml,
      buttons: [this.$t('Отмена'), this.$t('Сохранить')],
    }).then(async (doChange: any) => {
      if (doChange) {
        self.form.is_duplicate = true;
        self.submit('/donorsForm');
      }
    });
  }

  public yesNoOptionsClass(val: any) {
    if (val === '') {
      return 'outline-secondary';
    }
    return !val ? 'outline-warning' : 'outline-primary';
  }

  public beforeFetchData() {
    this.path = '/DonorsForm/getByLabId?labId=' + this.labId;
  }

  public clearProps(row, props) {
    for (const prop in row) {
      if (props.includes(prop)) {
        row[prop] = '';
      }
    }
  }

  public onFetchDataFinish() {
    // tslint:disable-next-line:prefer-for-of
    for(let i = 0; i < this.form.donor_first_contacts.length; i++) {
      for (const prop in this.form.donor_first_contacts[i]) {
         // tslint:disable-next-line:forin
        if (!this.form.donor_first_contacts[i].patient_id) {
          this.form.donor_first_contacts[i].patient_id = this.patientId;
        }
        if (this.form.donor_first_contacts[i][prop] === null) {
          this.form.donor_first_contacts[i][prop] = '';
        }
      }
    }
    if (this.form.donor_first_contacts.filter(f => f.patient_id === this.patientId).length === 0) {
      const contact = this.newContact();
      this.form.donor_first_contacts.push(contact);
    }
    if (this.requestDate) {
      this.form.request_date = this.requestDate;
    }
    this.setFirstContactsOrderIndex();
    this.startForm = JSON.stringify(this.form);
  }

  public setFirstContactsOrderIndex() {
    let index = 1;
    for (let i = 0; i < this.form.donor_first_contacts.length; i++) {
      this.form.donor_first_contacts[i].order_num = index;
      if (this.form.donor_first_contacts[i].patient_id === this.patientId) {
        index++;
      }
    }
  }

  public created() {
    this.getDictionaries();
    this.parentValidator.extend('isLabIdUnique', this.isLabIdUnique);
  }

  public getDictionaries() {
    axios.get('/pmdd/DictionaryGroup').then((response) => {
      this.genders = response.data.genders;
      this.biomaterialSamples = response.data.biomaterial_samples;
      this.learnedFroms = response.data.learned_froms;
      this.diseases = response.data.diseases;
      this.dataProcessingAgreements = response.data.data_processing_agreements;
      this.socialNetworks = response.data.social_networks;
      this.regions = response.data.regions;
      this.registerJoinTypes = response.data.register_join_types;
      this.bloodTypes = response.data.blood_types;
      this.rhs = response.data.rhs;
      this.deletionReasons = response.data.deletion_reasons;
      this.deletionReasons.unshift({ key: '', value: '...' });
      this.initialDeletionReasons = response.data.initial_deletion_reasons;
      this.initialDeletionReasons.unshift({ key: '', value: '...' });
    });
  }
}
